import { type FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';
import { FormattedMessage } from 'dibs-react-intl';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel.tsx';
import { pageTypeConstants } from '../../constants/pageTypeConstants.ts';

import styles from './SbSharedInteriorsHeader.scss';
import dibsCss from 'dibs-css';
import classnames from 'classnames';

import { type SbSharedInteriorsHeader_itemSearch$data } from './__generated__/SbSharedInteriorsHeader_itemSearch.graphql.ts';

type Props = {
    itemSearch: SbSharedInteriorsHeader_itemSearch$data;
};

const SbSharedInteriorsHeaderComponent: FC<Props> = ({ itemSearch }) => {
    const pageType = itemSearch?.pageType;
    const attributeDisplayName = itemSearch.meta?.attributeDisplayName || '';
    return (
        <>
            <HeadingLevel>
                {Heading => (
                    <Heading className={classnames(styles.sectionHeader, dibsCss.m0)}>
                        {pageType === pageTypeConstants.CREATOR ? (
                            <FormattedMessage
                                id="abf.SbRespInteriorsHeader.creatorHeader"
                                defaultMessage="Interiors Featuring {name}"
                                values={{
                                    name: attributeDisplayName,
                                }}
                            />
                        ) : (
                            <FormattedMessage
                                id="abf.SbRespInteriorsHeader.header"
                                defaultMessage="{name} Interiors"
                                values={{
                                    name: attributeDisplayName,
                                }}
                            />
                        )}
                    </Heading>
                )}
            </HeadingLevel>
            <div className={classnames(dibsCss.sassyFontBody, dibsCss.mtXsmall)}>
                <FormattedMessage
                    defaultMessage="Explore the work of the world's best interior designers"
                    id="abf.SbSharedInteriorsHeader.subheader"
                />
            </div>
        </>
    );
};

export const SbSharedInteriorsHeader = createFragmentContainer(SbSharedInteriorsHeaderComponent, {
    itemSearch: graphql`
        fragment SbSharedInteriorsHeader_itemSearch on ItemSearchQueryConnection {
            pageType
            meta {
                attributeDisplayName
            }
        }
    `,
});
